import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricRoiBing extends MetricBase {
    constructor() {
        super({
            field: "metric_roas",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.roi.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.roi.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.roi.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricRoiBing;
